import React, { useRef } from 'react';
import { murmurhash } from '../../../../../lib/js/hash';
import Form from '../../../../molecules/Form';
import { useDelayed } from '../../../../../hooks/useDelayed';
import IForm from '../../../../../types/IForm';
import { RefreshCallback } from '../../../../../_lib/FetchContainer';
import { CloseSecondaryView } from '../../BlockInteractionsTypes';
import { DeleteBlockFormTemplate } from './DeleteBlockFormTemplate';

type DeleteBlockFormType = {
  form: IForm;
  headline: string;
  transnamespaceAndKey: string;
  cancelAction: CloseSecondaryView;
  validateResponseStatus: () => void;
  refreshBlock: RefreshCallback;
};

export function DeleteBlockForm({
  form,
  headline,
  cancelAction,
  transnamespaceAndKey,
  validateResponseStatus,
  refreshBlock,
}: DeleteBlockFormType) {
  const headlineId = useRef(murmurhash(form.url));
  const delayedRefresh = useDelayed(refreshBlock);

  return (
    <Form
      id="submit-or-cancel-form"
      model={form}
      ariaLabelledby={headlineId.current}
      onSuccess={delayedRefresh}
      validateResponseStatus={validateResponseStatus}
    >
      <DeleteBlockFormTemplate
        cancelAction={cancelAction}
        headline={headline}
        headlineId={headlineId.current}
        transnamespaceAndKey={transnamespaceAndKey}
      />
    </Form>
  );
}
